<template>
  <div class="modal-window alert ab038">
    <header class="modal-header">
      <div class="tit">{{ modalInfo.title }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="info-txt small" style="white-space: pre-line">{{ modalInfo.contents }}</div>
    </div>

    <footer class="modal-footer">
      <button
        type="button"
        ref="btn2"
        class="btn_ty2"
        v-if="
          modalInfo.subButton != null &&
          modalInfo.subButton != '' &&
          modalInfo.subButton != undefined
        "
        @click="subConfirm"
      >
        {{ modalInfo.subButton }}
      </button>
      <button
        type="button"
        ref="btn1"
        class="btn_ty1"
        v-if=" modalInfo.button != null && modalInfo.button != '' && modalInfo.button != undefined && modalInfo.name != 'confirmHidden'"
        @click="confirm"
      >
        {{ modalInfo.button }}
      </button>
    </footer>
  </div>
</template>
<script>
export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    confirm() {
      if(this.modalInfo.buttonCallback != null) {
        this.$emit("close");
        this.modalInfo.buttonCallback(this.modalInfo);
      } else {
        this.$emit("dialogConfirm", this.modalInfo);
        this.$emit("close");
      }
    },
    subConfirm() {
      if(this.modalInfo.subButtonCallback != null) {
        this.$emit("close");
        this.modalInfo.subButtonCallback(this.modalInfo);
      } else {
        this.$emit("dialogSubConfirm", this.modalInfo);
        this.$emit("close");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if(this.modalInfo && this.modalInfo.autoFocus == true) {
        if(this.modalInfo.button != null || this.modalInfo.subButton != null) {
          if(this.$refs) {
            if(this.$refs.hasOwnProperty('btn1')) {
              this.$refs['btn1'].focus();
            }
            else if(this.$refs.hasOwnProperty('btn2')) {
              this.$refs['btn2'].focus();
            }
          }
        }
      }
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/common/alertMessage/Dialog.vue